import { sortAlpha } from "widgets/utils";

import type { GenomeMember } from "./process-genome-data.ts";

// Sorting paralogsData first by contig name and then by start position
export const getSortedParalogsData = (
  homologs: Map<number, GenomeMember[]>,
  organismId: number,
  memberFeatureId: number,
) => {
  return (
    (homologs.get(organismId) ?? [])
      // Remove current member from the list
      .filter((homolog) => homolog.locationId !== memberFeatureId)
      .sort((a, b) => {
        const contigComparison = sortAlpha(a.contigName, b.contigName);
        if (contigComparison !== 0) return contigComparison;
        return a.start - b.start;
      })
  );
};
